export const CHECKOUTS_TABLE_COLUMN = [
  { accessorKey: "$", header: "ردیف" },
  { accessorKey: "amount", header: "مبلغ (ریال)" },
  { accessorKey: "date", header: "تاریخ تراکنش" },
  { accessorKey: "trackingNumber", header: "کد رهگیری" },
  { accessorKey: "acceptorCode", header: " کد پذیرندگی" },
  { accessorKey: "transactionId", header: "شناسه تراکنش" },
  {
    accessorKey: "acceptorWageAmount",
    header: "مبلغ کارمزد (ریال)",
    size: 250,
  },
  { accessorKey: "isProcess", header: "وضعیت تسویه تراکنش", size: 250 },
  { accessorKey: "processDate", header: "تاریخ تسویه" },
 
];
